// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".li-style{width:calc(33% - 50px);margin-right:50px}@media(max-width:789px){.li-style{width:100%;margin-right:0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
